// @flow

import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

const ContactWrapper = styled.div`
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    margin: auto;
`;
const StyledAnchor = styled.a`
    color: #265a9c;
    text-decoration: none;
`;
const ContactParagraph = styled.p`
    margin: 5px;
`;

const ContactInfo = (props) => {
    return (
        <ContactWrapper
            {
            ...props
            } >
            <a
                href={props.website}
                target='_blank'
                rel="noopener noreferrer"
            >
                <img
                    src={props.logo}
                    style={{
                        height: '60px'
                    }}
                    alt='logo'
                />
            </a>

            <ContactParagraph>
               {props.companyName}
            </ContactParagraph>

            <ContactParagraph>
                {
                    props.address.map(addressPart =>
                        <span>{addressPart}<br /></span>
                    )
                }
            </ContactParagraph>

            <ContactParagraph>
                {
                    props.phones.map(phoneNo =>
                        <span>{phoneNo}<br /></span>
                    )
                }
            </ContactParagraph>

            <StyledAnchor
                href={`mailto:${props.mail}`}
            >
                {props.mail}
            </StyledAnchor>
        </ContactWrapper>
    );
}

const mapStateToProps = (state: State) => ({
    companyName: state.domainProperties.get('companyName'), 
    address: state.domainProperties.get('address'),
    phones: state.domainProperties.get('phones'),
    mail: state.domainProperties.get('mail'),
    website: state.domainProperties.get('website'),
    logo: state.domainProperties.get('companyLogo')
});
export default translate("translations")(connect(mapStateToProps, null)(ContactInfo));


// WEBPACK FOOTER //
// ./src/containers/content/grid/userWrapper/contactInfo/ContactInfo.jsx